import { useEffect, useState } from "react";
const useToken = (user) => {
    const [token,setToken]=useState('')
    useEffect(()=>{
 
        const email=user?.user?.email
        const currentUser={email:email}
        console.log(email)
        if(email)
        {
            fetch(`https://guarded-inlet-86447.herokuapp.com/user/${email}`,{
                method:'PUT',
                headers:{
                    'content-type':'application/json'
                },
                body:JSON.stringify(currentUser)
                
            }).then(res=>res.json())
            .then(data=>{
                console.log('data inside token',data)
                const accessToken=data?.token
                localStorage.setItem('accesstoken',accessToken)
                setToken(accessToken)
            })
        }

    },[user])
    return [token,setToken]
 
};

export default useToken;